export const DASHBOARD_ROUTE = '/dashboard';

export const ABOUT_ROUTE = '/about';

export const PRICING_ROUTE = '/pricing';

export const FAQ_ROUTE = '/faq';
